<template>
  <svg class="icon sort" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14">
    <path d="M4.306.304a.963.963 0 0 1 1.405 0L9.706 4.3c.281.28.375.718.219 1.092a.98.98 0 0 1-.906.625H1.03c-.407 0-.781-.25-.937-.625A1.01 1.01 0 0 1 .31 4.3L4.306.304Zm0 13.392L.31 9.7a1.01 1.01 0 0 1-.218-1.092c.156-.375.53-.625.936-.625H9.02c.375 0 .75.25.906.625A1.01 1.01 0 0 1 9.706 9.7l-3.995 3.996a.963.963 0 0 1-1.405 0Z" fill="#162F47"/>
  </svg>
</template>
